import Breadcrumb from "../components/Breadcrumb";
import AddBlogForm from "../components/blog/AddBlogForm";

const AddBlogPage = () => {
  return (
    <>
      <Breadcrumb title="Add Blog" />
      <AddBlogForm />
    </>
  );
};

export default AddBlogPage;

